/**
 * Deep links into Kombyapp. URLs live in kombyApp.json (no host hardcode here).
 * Social / Buzz is the app route `/social` — not a dashboard on komby.io.
 */
import appConfig from './kombyApp.json';

export type KombyAppRoute = keyof typeof appConfig.routes;

export function getKombyAppOrigin(): string {
  return appConfig.origin.replace(/\/$/, '');
}

export function getKombyAppUrl(route: KombyAppRoute): string {
  const path = appConfig.routes[route];
  return `${getKombyAppOrigin()}${path.startsWith('/') ? path : `/${path}`}`;
}

export function openKombyApp(
  route: KombyAppRoute,
  target: '_blank' | '_self' = '_blank'
): void {
  if (typeof window === 'undefined') return;
  window.open(getKombyAppUrl(route), target, 'noopener,noreferrer');
}
